import React from "react";
import styled from "styled-components";

const PageContainer = styled.section`
  max-width: 960px;
  margin: 0 auto;
  padding: 64px 20px;
  color: #1f2937;
`;

const Title = styled.h1`
  font-size: 28px;
  line-height: 1.4;
  margin: 0 0 24px;
  font-weight: 700;
`;

const Content = styled.pre`
  white-space: pre-wrap;
  word-break: keep-all;
  line-height: 1.8;
  font-size: 15px;
  margin: 0;
  font-family: inherit;
`;

const PRIVACY_TEXT = `
개인정보처리방침

총칙
㈜나인투랩스 (이하 '92Labs', 'Ninetwolabs Inc.',)는 이용자의 소중한 개인정보를 보호하기 위해 개인정보보호 관련 법령을 준수합니다.
개인정보처리방침을 통해 ‘나인투랩스’가 어떠한 개인정보를 수집하고, 어떻게 이용하며, 누구에게 제공하는지, 언제 어떻게 파기하는지 등에 대해 이해할 수 있으며 본 개인정보처리방침은 게임 서비스뿐만 아니라 ‘나인투랩스’가 제공하는 타 서비스와 직간접적으로 연관이 있는 부가 서비스에도 적용됩니다.

1. 개인정보의 수집
‘나인투랩스’는 서비스 이용 시 필요한 개인정보만을 수집하며, 수집 시에는 이용자에게 상세히 안내하고 동의를 받아 처리하고 있습니다.

■ 필수정보란?
기본적인 서비스를 제공하기 위해 수집하는 개인정보

■ 선택정보란?
기본적인 서비스 이외에 부가적인 서비스를 제공하기 위해 수집하는 개인정보

1. 웹페이지, 앱, 서면, 전화, 팩스 등의 방법을 통해 아래와 같은 개인정보를 수집합니다.
2. ‘소셜로그인’ 또는 ‘SSO(Single-Sign-On)’과 같이 다른 회사(Google, Apple 등)의 계정으로 게임 서비스를 이용하는 경우 해당 회사로부터 이용자 식별을 위한 데이터와 이용자에게 동의를 받은 개인정보만을 제공받고 동의한 목적 범위 내에서만 처리됩니다.
- 회원가입: 웹페이지 내 회원가입 서비스 없음(게임 서비스내 제공)
- 보호자동의:  [필수] 본인확인정보(이름, 생년월일, 성별, 내외국인정보, 휴대폰번호, 중복가입정보(DI)), 부모자 동의서(가족관계증명서, 휴대폰가입자명의확인서, 결제내역서), 이메일주소
- 게임서비스: [필수] 닉네임, 본인확인정보(Google 및 Apple 소셜 로그인 정보, 중복가입확인정보)
- 결제: [필수] Google Play, Apple Appstore의 결제 및 결제처리정책에 따릅니다. (인앱 결제)
- 환불 처리: [필수] 닉네임, 본인확인정보(Google 및 Apple 소셜 로그인 정보, 중복가입정보(DI)), 계좌정보(은행명, 예금주명, 계좌번호), 결제 정보
(문의 유형에 따라 추가로 수집하는 개인정보가 있을 수 있습니다. *청소년 청약철회의 경우, 보호자 동의사항 정보 포함)
- 이벤트 등 프로모션 알림 전송: [선택] 휴대폰번호, 운영체제(Android, iOS), 이메일주소
- 경품 및 상품배송: [필수] 이름, 휴대폰번호, 이메일주소, 주소, 운영체제(Android, iOS)
- 상금지급 및 포인트 전환: [필수] 닉네임, 본인확인정보(Google 및 Apple 소셜 로그인 정보, 중복가입정보(DI)), 계좌정보(은행명, 예금주명, 계좌번호)
- 제세공과금처리: [필수] 이름, 닉네임, 휴대폰번호, 이메일주소, 주소
- 공지사항전달: [필수] 휴대폰번호, 이메일주소
- 이벤트 및 행사 참여: [선택] 이름, 휴대폰번호, 성별, 생년월일, 이메일주소, 주소, 운영체제(Android, iOS)
- 문의대응: [필수] 닉네임, 이메일주소(비회원 문의 시) [선택] ID, 이름, 이메일주소, 휴대폰번호, 생년월일, 성별, 주소, 전화번호, 본인확인정보(Google 및 Apple 소셜 로그인 정보), 결제 정보
(문의 유형에 따라 추가로 수집하는 개인정보가 있을 수 있습니다.)

나인투랩스의 모든 서비스의 서비스 안정성 확보, 부정이용자 방지, 계정 및 아이템 보호, 법률 및 이용약관 위반 행위 제한 등의 목적으로 서비스를 이용하는 과정에서 자동으로 생성되는 정보(IP, 접속기록, 서비스 이용기록, 불량이용 기록, 다운로드 기록, 결제 기록, 쿠키)와 기기를 식별할 수 있는 정보(OS 정보, 하드웨어 정보, Mac Address, UUID, 광고식별자), 위치정보가 추가적으로 수집, 제공될 수 있습니다.
인플루언서의 경우 당사의 시스템 등록을 위해 YouTube API를 이용하여 채널 정보를 수집할 수 있으며 YouTube API Services 이용약관(https://developers.google.com/youtube/terms/api-services-terms-of-service)과 Google 개인정보처리방침(https://policies.google.com/privacy)을 준수합니다.

2. 개인정보의 이용
나인투랩스는 아래의 목적으로 개인정보를 이용하며, 목적이 변경될 경우에는 이용자에게 상세히 안내하고 동의를 받아 처리하고 있습니다.
- 이용자를 식별하고, 본인임을 확인하는 등 회원 관리를 위해 개인정보를 이용합니다.
- 온라인게임, 모바일게임 서비스 및 게임서비스와 직간접적으로 연관이 있는 부가 서비스를 제공하기 위해 개인정보를 이용합니다.
- 당사 서비스내 게임머니 충전, 환불 등 결제를 위해 개인정보를 이용합니다.
- 이벤트 등 프로모션 알림을 위해 개인정보를 이용합니다.
- 이벤트 참여 의사를 확인하고 이벤트 참여자에 대한 경품 배송, 제세공과금 처리 등을 위해 개인정보를 이용합니다.
- 약관 변경, 서비스 장애, 게임이용내역, 개인정보이용내역 등 서비스 운영을 위한 공지사항을 전달하기 위해 개인정보를 이용합니다.
- 문의에 대한 대응을 하거나 불만 처리, 이용자 서비스 개선을 위해 개인정보를 이용합니다.
- 안전하게 서비스를 이용할 수 있는 환경을 만들기 위해 개인정보를 이용합니다.
- 부정가입 및 이용 방지를 위해 개인정보를 이용합니다.
- 서비스 이용 기록 등을 통해 서비스 이용 환경을 분석하고 서비스 개선 및 이용자의 특성을 고려한 서비스 제공을 위해 개인정보를 이용합니다.

3. 개인정보의 제공
이용자가 보다 편리하고 신속하게 서비스를 이용할 수 있도록 다른 회사에게 일부 업무를 위탁하고 있습니다.
나인투랩스의 업무를 처리위탁 받은 회사가 이용자의 소중한 개인정보를 안전하게 처리하도록 관리·감독하며, 나인투랩스의 사전 승인 없이 또 다른 회사에게 재위탁하지 않도록 제한합니다.
나인투랩스는 아래와 같은 업무를 위탁하고 있습니다.
- 대상: ㈜모비데이즈, 아이브코리아
  목적: 서비스 사용 리서치, 광고 집행(사전예약, 예약별 퀘스트, 쿠폰 제공 등)
- 대상: ㈜누리고
  목적: 문자메시지, 카카오 비즈메시지 발송

원활하고 안정적인 게임 서비스 제공을 위해 아래와 같이 개인정보를 국내(일부 국외) 서버에 보관합니다.
- 항목: 닉네임, 이메일주소, 소셜 로그인 정보, 결제 정보
  국가: 서울
  이전 일시 및 방법: 게임 서비스 이용 시점에 네트워크를 통한 전송
  이전 받는 자: Amazon Web Services Inc., (https://aws.amazon.com/compliance/contact)
  목적: 클라우드 서버 운영 및 관리
  보유 및 이용 기간: 게임 탈퇴 후 30일 보관
- 항목: 닉네임, 이메일주소 (문의, 제공형태에 따라 추가 정보를 수집할 수 있습니다)
  국가: 미국
  이전 일시 및 방법: 메일 발송 시 네트워크를 통한 전송
  이전 받는 자: Google Inc., (https://policies.google.com/privacy?hl=ko)
  목적: 이용자 이용안내용 메일 발송, 이용자 문의 응대, 확인, 이메일 보관
  보유 및 이용 기간: 이메일 발송 후 1년 이내

나인투랩스의 모든 서비스의 서비스 안정성 확보, 부정이용자 방지, 계정 및 아이템 보호, 법률 및 이용약관 위반 행위 제한 등의 목적으로 서비스를 이용하는 과정에서 자동으로 생성되는 정보(IP, 접속기록, 서비스 이용기록, 불량이용 기록, 다운로드 기록, 결제 기록, 쿠키)와 기기를 식별할 수 있는 정보(OS 정보, 하드웨어 정보, Mac Address, UUID, 광고식별자), 위치정보가 추가적으로 수집, 제공될 수 있습니다.

4. 개인정보의 파기
나인투랩스는 개인정보 수집 및 이용 목적 달성되거나 보유기간이 만료되면 해당 정보를 지체 없이 파기합니다. 다만, 관계 법령에 규정되거나 이용자에게 동의를 얻은 경우는 예외로 하고 있습니다.

- 전자상거래 등에서의 소비자보호에 관한 법률(계약 또는 청약철회 등에 관한 기록) 5년
- 대금결제 및 재화 등의 공급에 관한 기록, 5년
- 소비자의 불만 또는 분쟁처리에 관한 기록, 3년
- 국세기본법, 소득세법(세법이 규정하는 처리에 관한 기록) 5년
- 통신비밀보호법(로그인에 관한 기록) 3개월

회원/게임을 탈퇴하는 경우 서비스 제공을 위해 수집한 정보는 소비자 불만 및 분쟁 해결 목적으로 탈퇴일로부터 최대 30일간 보관 후에 삭제합니다.
부정이용기록은 부정 가입 및 이용 방지를 위하여 회원탈퇴일로부터 1년간 보관 후에 삭제합니다.
이벤트 등을 위해 수집한 정보는 최대 3년간 보관하나 이는 이벤트 마다 상이할 수 있으며 개별 이벤트 페이지에 기재된 기간과 이용자 동의를 우선합니다.
문자메시지 전송 이력은 전송일로부터 1년 간 보관 후에 삭제합니다.
이용자의 동의에 따라 1년 혹은 5년동안 서비스를 이용하지 않은 이용자의 개인정보는 별도로 분리하여 안전하게 보관하고 있습니다.

전자적 파일 형태의 개인정보는 다시 이용할 수 없도록 기술적인 방법을 통해 삭제하며, 그 밖에 종이에 출력된 개인정보는 분쇄합니다.

5. 이용자 및 법정대리인의 권리와 그 행사 방법
나인투랩스는 이용자 개인정보의 열람, 제공, 정정 요청에 대해 적극적으로 필요한 조치를 합니다. 만14세 미만 아동의 법정대리인은 관계 법령에서 정하는 규정되는 아동 개인정보의 열람, 정정, 삭제, 처리정지, 동의 철회, 결제 철회를 요청할 수 있는 권리를 가집니다.
개인정보보호책임자에게 전화, 전자우편 등을 통해 개인정보 열람, 정정, 삭제, 처리정지, 동의 철회를 요구할 수 있습니다. (단, 소셜 로그인으로 당사의 서비스에 가입한 경우, 각 회사의 방침에 따라 일부만 수집되므로, 이용자 또는 보호자가 직접 당사에 서면 소명자료를 제출하여 처리합니다.)

6. 개인정보 자동수집 장치의 설치·운영 및 그 거부에 관한 사항
나인투랩스는 이용자에게 편리한 웹사이트 사용 환경을 제공하기 위해 쿠키를 사용하며 이를 거부할 수 있는 권리를 가집니다.

■ 쿠키란?
특정 웹사이트에서 웹서버가 웹브라우저에게 전달하는 작은 텍스트 파일

서비스 개선을 위해 쿠키를 이용하여 이용자의 접속 기록, 이용 형태 등을 파악합니다.
이용자는 브라우저에서 옵션 설정을 통해 쿠키가 수집되지 않도록 거부할 수 있습니다.
- Internet Explorer:  도구 > 인터넷 옵션 > 개인정보 > 고급
- Chrome: 설정 > 개인정보 및 보안 > 쿠키 및 기타 사이트 데이터
그 외 브라우저의 경우 브라우저 별 설정 방식에 따릅니다.

■ 웹로그 분석이란?
웹사이트상에서 이용자의 서비스 이용 형태에 대한 분석을 의미합니다.
회사는 Google Analytics와 같이 다양한 외부 웹로그분석 도구를 사용할 수 있으며 Google Analytics의 경우 데이터가 사용되는 것을 거부할 수 있습니다.
* Google Analytics 차단: https://tools.google.com/dlpage/gaoptout/
그 외 웹로그분석 도구의 경우 도구 별 거부 방식에 따릅니다

■ 온라인 맞춤형 광고란?
이용자의 온라인 이용 형태, 접속 기록 등을 분석하여 이용자의 특성을 고려한 서비스를 제공 하는 마케팅 기법을 의미합니다.
온라인 맞춤형 광고 사업자가 행태정보를 수집하도록 허용하고 있습니다.
- 광고사업자: 구글, 페이스북, 트위터, 클릭몬, 타켓팅게이츠, 리얼클릭, 크리테오, AdJust, Tune, AppsFlyer, adbrix, Admob, Unity Ads, AdColony, MOLOCO, 버즈빌, Kakao, Taboola, 인라이플
- 행태정보 수집하는 방법: 이용자가 사이트를 방문하거나 앱을 실행할 때 자동 수집

7. 개인정보를 보호하기 위한 노력
나인투랩스는 이용자의 소중한 개인정보를 보호하기 위해 적극적으로 노력하고 있습니다.
- 개인정보를 암호화하고 있습니다.
  비밀번호, 고유식별정보, 휴대전화번호, 이메일주소 등 개인을 식별할 수 있는 중요 개인정보는 암호화하여 저장하며 이렇게 암호화된 개인정보는 암호화 통신을 이용하여 안전하게 전송하고 있습니다. (단, 소셜로그인의 경우 각 회사별 개인정보취급방침에 따라 처리)
- 개인정보를 보호하기 위한 기술에 지속적으로 관심을 가지고 있습니다.
  해커 등의 침입을 24시간 탐지하고 차단하고 있습니다. 또한, 악성코드나 바이러스에 감염되지 않도록 백신프로그램을 설치하고 운영하고 있습니다.
- 개인정보를 다루는 직원을 최소화하고 있습니다.
  최소한의 직원만 개인정보를 다루게 되며, 개인정보를 처리하는 PC에서는 외부 인터넷을 사용할 수 없도록 차단하거나 그에 준하는 보호조치를 적용하여 개인정보유출에 대한 위험을 줄이고 있습니다.
- 교육, 캠페인을 실시하고 있습니다.
  개인정보보호를 위한 정기적인 교육, 캠페인을 통해 개인정보의 중요성에 대해 강조하고 있습니다.
- 국내외 인증기관으로부터 검증을 받고 있습니다.
  정보보호 인증기관 또는 위탁기관으로부터 매년 정보보호활동에 대한 인증을 취득합니다.

나인투랩스는 개인정보 관련 문의 및 불만 처리 등을 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.
- 개인정보보호책임자
  이름: 정종훈
  직위: 감사
  이메일주소: privacy@ninetwolabs.com
  l  개인정보 보호 담당부서로 연결됩니다.

정보주체께서는 나인투랩스 전체 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사와 개인정보책임자는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.

기타 개인정보침해에 대한 피해구제, 상담은 아래의 기관에 문의하실 수 있습니다.
- 개인정보침해 신고센터
  전화번호: 국번없이 118
  웹사이트: https://privacy.kisa.or.kr
- 개인정보 분쟁조정위원회
  전화번호: 국번없이 1833-6972
  웹사이트: https://www.kopico.go.kr
- 대검찰청 사이버수사과
  전화번호: 국번없이 1301
  웹사이트: https://www.spo.go.kr
- 경찰청 사이버안전국
  전화번호: 국번없이 182
  웹사이트: https://ecrm.cyber.go.kr

8. 기타
개인정보처리방침 내용에 변경이 있을 경우 개정 최소 7일전에 알려드리나 이용자의 권리에 중대한 변경이 발생할 때에는 최소 30일전에 알려드립니다.

공고일: 2021년 08월 7일
시행일: 2021년 08월 16일
`;

export const Privacy = () => {
  return (
    <PageContainer>
      <Title>개인정보처리방침</Title>
      <Content>{PRIVACY_TEXT}</Content>
    </PageContainer>
  );
};


